<div class="popup-wrapper--body" appScroll (scrollEvent)="handleScroll()">
  <div class="popup-wrapper--body-in">
    <ng-container *ngIf="!assetsData?.length; else assetsTmpl">
      <div class="empty-assets-text" *ngIf="!isLoading; else loading">
        No image available. Only NFT images in your connected wallet can be
        used.
      </div>
      <ng-template #loading>
        <div class="choose-image-wrap">
          <label
            class="choose-image-tile loading"
            *ngFor="let arr of 12 | toArray"
          >
          </label>
        </div>
      </ng-template>
    </ng-container>
    <ng-template #assetsTmpl>
      <div class="choose-image-wrap">
        <label class="choose-image-tile" *ngFor="let asset of assetsData">
          <input
            type="radio"
            class="choose-image-input"
            name="choose-image-input"
            (change)="handleImageSelect.emit(asset.tokenId)"
          />
          <div class="choose-image-checkmark">
            <svg class="choose-image-icon" viewBox="0 0 32 32">
              <use href="#check"></use>
            </svg>
          </div>
          <img class="choose-image-media" [src]="asset.url" />
        </label>
      </div>
    </ng-template>
  </div>
</div>
